import CrudRepository from './CrudRepository'

export default class ContactsRepository extends CrudRepository {
  constructor () {
    super('contacts')
  }
}
